<style scoped>
  .user-invite {
    background: #fff;
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
  }
  .user-invite > .user-holder{
    display: flex;
    max-width: 280px;
  }

  .user-holder > .avatar{
    margin-right: 10px;
  }

  .user-invite > #modal-holder{
    display: none;
  }

  .user-info{
    overflow: hidden;
  }

  .user-info > h3{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .pending-invite-holder{
    background: #fff;
    padding: 15px;
  }

  .pending-invite-holder > h3{
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
  }

  .empty-invites{
    margin-top: 10px;
    text-align: center;
    color: #aaa;
  }
</style>

<template>
  <div class="pending-invite">
    <div class="pending-invite-holder">
      <h3>Pending Group Invites</h3>
      <div class="empty-invites" v-if="pendingInvites.length == 0">
        Currently no pending invites
      </div>
      <div class="user-invite" v-for="invite in pendingInvites">
        <div class="user-holder" v-if="checkHasJournal(invite.journal)">
          <div class="avatar">
            <Avatar shape="square" icon="person" size="large" :src="invite.journal.owner.avatar" />
          </div>
          <div class="user-info">
            <h3>{{invite.journal.owner.display_name}}</h3>
          </div>
        </div>
        <div class="user-holder" v-else-if="!checkHasJournal(invite.journal)">
          <div class="avatar">
            <Avatar shape="square" icon="person" size="large" />
          </div>
          <div class="user-info">
            <h3>{{invite.comment}}</h3>
          </div>
        </div>
        <div class="action-buttons">
          <Button icon="android-close" class="reject" v-on:click="showRemoveConfirmation = true"></Button>
        </div>
        <ModalHolder :title="'Confirm'" m-top="0" :is-show="showRemoveConfirmation">
          <template slot="mcontent">
            <p>Are you sure you want to cancel this invitation?</p>
          </template>
          <template slot="mfooter">
              <Button type="text" @click="showRemoveConfirmation = false">Cancel</Button>
              <Button type="default" v-on:click="cancelInvitaion(invite)" :loading="cancelInvitationLoader">Confirm</Button>
          </template>
        </ModalHolder>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalHolder from "@/components/ModalHolderComponent";
  import _ from "lodash";

  export default {
    name: 'PendingInviteComponent',
    data(){
      return {
        premissions: Cons[0].PERMISSIONS,
        showRemoveConfirmation: false,
      }
    },
    components: {
      ModalHolder
    },
    computed: {
      pendingInvites: {
        get() {
          return this.$store.state.resource.singleResource.groupInvites;
        }
      },
      singleResource: {
        get() {
          return this.$store.state.resource.singleResource.data;
        }
      },
      cancelInvitationLoader: {
        get() {
          return this.$store.state.resource.singleResource.cancelInvitationLoader;
        }
      },
    },
    methods: {
      getPermissionLabel(value){
        for(let i=0; i<this.premissions.length; i++){
          if(value == this.premissions[i].value){
            return this.premissions[i].label;
          }
        }
      },
      checkHasJournal(journal){
        return _.get(journal, 'id')
      },
      cancelInvitaion(data){
        this.$store.dispatch("resource/cancelInvitation", data.id).then(res => {
          this.$Message({
            closable: true,
            // durationInSec:3,
            title: { content:'Canceled' },
            icon: 'checkmark',
            message: { content: 'Invitation canceled' },
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
            ]
          });                
          this.showRemoveConfirmation = false;
        });
      }
    }
  }
</script>
